export default __webpack_public_path__ + "static/media/splash-register-right.47df5a54.svg";